<form
  *ngIf="form && !loading && (importCsvData$ | async) as importCsvData"
  [formGroup]="form"
  (submit)="onFormSubmit()"
  class="gonvarri-import-entries-form"
>
  <ng-container *cxFeature="'a11yCartImportConfirmationMessage'">
    <div aria-live="assertive" aria-atomic="true">
      <cx-message
        *ngIf="form.get('file')?.value && form.get('file')?.valid"
        [text]="'importEntriesDialog.selectedSuccessfully' | cxTranslate"
        [type]="globalMessageType.MSG_TYPE_CONFIRMATION"
        [isVisibleCloseButton]="false"
        [cxFocus]="{ autofocus: '.cx-message' }"
      ></cx-message>
    </div>
  </ng-container>
  <div>
    <strong>
      {{ 'importEntriesDialog.importProductsRulesTitle' | cxTranslate }}
    </strong>
    <ul>
      <li>{{ 'importEntriesDialog.importProductsFirstRule' | cxTranslate }}</li>
      <li>{{ 'importEntriesDialog.importProductsSecondRule' | cxTranslate }}</li>
    </ul>
  </div>
  <hr/>
  <p>
    {{ 'importEntriesDialog.importProductsSubtitle' | cxTranslate }}
  </p>
  <hr/>
  <p>
    <strong>{{ 'importEntriesDialog.importProductFileDetails' | cxTranslate }}</strong> <button
      class="file-template-import"
      (click)="downloadFile(importCsvData.excelSampleFileUrl)"
      type="button"
    >
      {{ 'importEntriesDialog.importProductClickHere' | cxTranslate }}
    </button> {{ 'importEntriesDialog.importProductFileDetailsFinal' | cxTranslate }}
  </p>
  <hr/>
  <label>
    <cx-file-upload [formControl]="getFormControl(form.get('file'))" [accept]="allowedTypes">
      {{ 'importEntriesDialog.selectFile' | cxTranslate }}
    </cx-file-upload>
    <cx-form-errors
      [control]="form.get('file')"
      prefix="formErrors.file"
    ></cx-form-errors>
  </label>
  <div
    class="cx-import-entries-footer"
  >
    <button
      (click)="close('Close Import Products Dialog')"
      class="btn btn-secondary"
      type="button"
    >
      {{ 'importEntriesDialog.cancel' | cxTranslate }}
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="form.get('file')?.status === 'PENDING'"
    >
      {{ 'importEntriesDialog.upload' | cxTranslate }}
    </button>
  </div>
</form>
<cx-spinner
  *ngIf="loading"
/>
